import { ref, watchEffect } from "vue";

const token_key = "tenant_console_token";

const isClient = typeof window !== "undefined";
let token = ref<string | null>(isClient ? localStorage.getItem(token_key) : null);

export function useToken() {
  const getToken = (): string | null | undefined => {
    if (token_key) {
      return isClient ? localStorage.getItem(token_key) : null;
    }
  };

  const setToken = (t: string): void => {
    token.value = t;
    if (token_key) {
      localStorage.setItem(token_key, t);
    }
  };

  const removeToken = (): void => {
    token.value = null;
    if (token_key) {
      localStorage.removeItem(token_key);
    }
  };

  const isAuthenticated = ref(false);
  watchEffect(() => {
    isAuthenticated.value = !!token.value;
  });

  return { getToken, setToken, removeToken, isAuthenticated };
}
